import { useEffect, useState } from "react";
import { ShareSheet } from "./ShareSheet";

/**
 * Global host that opens the full ShareSheet (with Bronze/Silver/Gold
 * referral tiers) from anywhere via a window CustomEvent. Pure UI,
 * no new engines/polling/realtime.
 *
 *   window.dispatchEvent(new CustomEvent("ss2026:open-share-sheet"));
 */
export function ShareSheetHost() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("ss2026:open-share-sheet", handler);
    return () => window.removeEventListener("ss2026:open-share-sheet", handler);
  }, []);
  return <ShareSheet open={open} onClose={() => setOpen(false)} />;
}

export function openShareSheet() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("ss2026:open-share-sheet"));
}